// src/admin_module/components/customer_reviews/AdminReviewsPage.jsx

import React, { useEffect, useState } from "react";
import { FaStar, FaRegStar, FaCheckCircle, FaTrash, FaEdit } from "react-icons/fa";
import { motion } from "framer-motion";

import {
 fetchAllReviewsAdmin,
 deleteReviewAdmin,
 verifyReviewAdmin,
 updateReviewAdmin,
} from "../../services/adminReviewServices";
import AddReviewModal from "./AddReviewModal";

const AdminReviewsPage = () => {
 const [reviews, setReviews] = useState([]);
 const [loading, setLoading] = useState(true);
 const [showModal, setShowModal] = useState(false);
 const [editReview, setEditReview] = useState(null);

 // ================= LOAD REVIEWS =================
 const loadReviews = async () => {
 try {
 setLoading(true);
 const res = await fetchAllReviewsAdmin();
 setReviews(res.data || []);
 } catch (err) {
    } finally {
 setLoading(false);
 }
 };

 useEffect(() => {
 loadReviews();
 }, []);

 // ================= ACTIONS =================
 const handleEdit = (review) => {
 setEditReview(review);
 setShowModal(true);
 };

 const handleDelete = async (id) => {
 if (!window.confirm("Are you sure you want to delete this review?")) return;
 try {
 await deleteReviewAdmin(id);
 loadReviews();
 } catch (err) {
 // alert("Failed to delete review");
 }
 };

 const handleVerifyToggle = async (review) => {
 try {
 await verifyReviewAdmin(review.id, !review.verified);
 loadReviews();
 } catch (err) {
 // alert("Failed to update review verification");
 }
 };

 const handleSubmitReview = async (data) => {
 try {
 if (!editReview) return;

 await updateReviewAdmin(editReview.id, {
 rating: data.rating,
 review: data.review || data.comment,
 userId: editReview.userId,
 });

 setShowModal(false);
 setEditReview(null);
 loadReviews();
 } catch (err) {
 // alert("Failed to submit review");
 }
 };

 return (
 <div style={{ maxWidth: 1200, margin: "40px auto", padding: "0 20px" }}>
 <h2 style={{ fontSize: 28, marginBottom: 20 }}>Admin: User Reviews</h2>

 {loading && <p style={{ textAlign: "center" }}>Loading reviews...</p>}

 <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
 {reviews.map((review) => (
 <motion.div
 key={review.id}
 initial={{ opacity: 0, y: 10 }}
 animate={{ opacity: 1, y: 0 }}
 style={{
 background: "#fff",
 borderRadius: 12,
 padding: 20,
 boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
 display: "flex",
 flexDirection: "column",
 gap: 8,
 }}
 >
 {/* USER & DATE */}
 <div style={{ display: "flex", justifyContent: "space-between" }}>
 <strong>{review.userName}</strong>
 <span style={{ fontSize: 12, opacity: 0.7 }}>
 {new Date(review.createdAt).toLocaleDateString()}
 </span>
 </div>

 {/* RATING STARS */}
 <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
 {[1, 2, 3, 4, 5].map((i) =>
 i <= review.rating ? (
 <FaStar key={i} size={14} color="#FFD700" />
 ) : (
 <FaRegStar key={i} size={14} color="#FFD700" />
 )
 )}

 {review.verified && (
 <span
 style={{
 display: "inline-flex",
 alignItems: "center",
 gap: 4,
 fontSize: 12,
 padding: "2px 6px",
 borderRadius: 8,
 background: "#E3F2FD",
 color: "#1976D2",
 marginLeft: 8,
 }}
 >
 <FaCheckCircle size={12} /> Verified
 </span>
 )}
 </div>

 {/* REVIEW TEXT */}
 {review.review && <p>{review.review}</p>}

 {/* ACTIONS */}
 <div style={{ display: "flex", gap: 12, marginTop: 6 }}>
 <button style={actionBtn} onClick={() => handleEdit(review)}>
 <FaEdit size={12} /> Edit
 </button>
 <button
 style={{ ...actionBtn, color: "#F44336" }}
 onClick={() => handleDelete(review.id)}
 >
 <FaTrash size={12} /> Delete
 </button>
 <button
 style={{
 ...actionBtn,
 color: review.verified ? "#1976D2" : "#FF9800",
 }}
 onClick={() => handleVerifyToggle(review)}
 >
 {review.verified ? "Unverify" : "Verify"}
 </button>
 </div>
 </motion.div>
 ))}
 </div>

 {/* MODAL */}
 <AddReviewModal
 open={showModal}
 onClose={() => setShowModal(false)}
 onSubmit={handleSubmitReview}
 initialRating={editReview?.rating || 0}
 initialComment={editReview?.review || ""}
 isEdit={!!editReview}
 />
 </div>
 );
};

/* ================= STYLES ================= */
const actionBtn = {
 background: "transparent",
 border: "none",
 cursor: "pointer",
 fontSize: 13,
 display: "inline-flex",
 alignItems: "center",
 gap: 4,
};

export default AdminReviewsPage;
